import React, { useEffect, useState } from 'react';
import './newsSection.css'
import newsVideo from "../../../assets/video/video.mp4"
import NewsMain from '../NewsMain/NewsMain';
import NewsSlider from '../NewsSlider/NewsSlider';
import client from '../../../utils/prismicHelpers';
import * as queries from "../../../utils/prismicQueries";
import banner from "../../../assets/images/723x330.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import ReactPlayer from 'react-player';
import Posts from '../Posts/Posts';


const NewsSection = () => {

    const [newsSlider, setAllPost] = useState(null);
    const [newsContent, setNewsContent] = useState(null);
    useEffect(() => {
        client
            .query({
                query: queries.news,
            })
            .then((response) => {
                const newsContent = response.data.allNewss.edges[0].node;
                setNewsContent(newsContent);
                setAllPost(newsContent.slider_info);

            })
            .catch((error) => {
                console.error(error);
            });
    });

    return (
        <section style={{ backgroundImage: `url(${newsContent?.news_bg?.url})` }} className='news-container '>
            <div className="container">
                <h5 className='section-title'>{"News & Videos"}</h5>
                <h3 className="subtitle">{"News & Videos"}</h3>
                <div className="news-banner">
                    <div className="card mb-3" >
                        <div className="row g-0">
                            <div className="col-md-8">
                                <img className=" news-banner-img" src={newsContent?.card_bg?.url} alt="" />
                                {/* <img className=" img-fluid" src={newsContent?.card_bg?.url} alt="" /> */}
                                {/* <ReactPlayer
                                    className='react-player '
                                    url={newsContent?.video_banner1?.embed_url}
                                    playing={true}
                                    light={newsContent?.video_banner1?.thumbnail_url}
                                    volume={0}
                                    width='100%'
                                    height='350px'
                                /> */}

                            </div>
                            <div className="col-md-4 d-flex flex-column justify-content-between ">
                                <div className="card-body ">
                                    <div className="d-flex justify-content-center">
                                        <img className=" img-fluid news-banner-img" src={newsContent?.card_logo?.url} alt="" />
                                    </div>
                                    {/* <h5 className="card-title">{newsContent?.logo_name[0]?.text}</h5> */}
                                    <p className="card-text pt-3 ps-0 secondary-text" >{newsContent?.card_title[0]?.text}</p>
                                    <p className="card-text pt-1 ps-0">{newsContent?.card_info[0]?.text}</p>
                                </div>
                                <div className=" d-flex justify-content-start pb-2 ps-2">
                                    <a target="_blank" href={newsContent?.btn_link1[0]?.text} className="news-read-more"> {newsContent?.btn_text[0]?.text} <span className="ms-1"><FontAwesomeIcon icon={faChevronRight} /></span></a>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="features-section pt-5">

                    <div >
                        {newsSlider != null ? <NewsSlider newsSlider={newsSlider.filter(news => news.is_featured === true)}></NewsSlider> : null}
                    </div>
                </div>
                <div className="post-container py-5 mb-5">
                    <div className="d-flex justify-content-between ">
                        <h5 className='section-title'>All Posts</h5>
                        {/* <div className="pb-3">
                            <select className="form-select " aria-label="Default select example">
                                <option defaultValue="0" >Newest First</option>
                                <option defaultValue="1">One</option>
                                <option defaultValue="2">Two</option>
                                <option defaultValue="3">Three</option>
                            </select>
                        </div> */}
                    </div>

                    <div >
                        {newsSlider != null ? <Posts newsSlider={newsSlider}></Posts> : null}

                        {/* <nav className="d-flex justify-content-center my-5" aria-label="Page navigation example " >
                            <ul className="pagination ">

                                <li className="page-item mx-2"><a className="page-link" href="#">1</a></li>
                                <li className="page-item mx-2"><a className="page-link" href="#">2</a></li>
                                <li className="page-item mx-2"><a className="page-link" href="#">3</a></li>
                                <li className="page-item mx-2">
                                    <a className="page-link" href="#" aria-label="Next">
                                        <span ><FontAwesomeIcon icon={faChevronRight} /></span>
                                    </a>
                                </li>
                            </ul>
                        </nav> */}

                    </div>
                </div>

            </div>
        </section>

    );
};

export default NewsSection;